/* eslint-disable no-param-reassign */
import * as Sentry from '@sentry/nextjs';
import axios from 'axios';
import { ServiceBuilder } from 'ts-retrofit3';

import { SERVICE_GLOBAL_ERROR } from '@/Module/Core/Constant';
import { enqueueError, isBrowser } from '@/Module/Core/Helper';
import { EXAM_API_BASE } from '@/Module/Exam/Constant';

import ExamCookieService from './ExamCookieService';

const axiosExamInstance = axios.create({});

axiosExamInstance.interceptors.response.use(
  config => config,
  failedRequest => {
    const { response, config, code } = failedRequest;

    if (isBrowser() && !config?.extraMap?.disabledAutoError && code !== 'ERR_CANCELED') {
      const message = response?.data?.errors?.[0] || SERVICE_GLOBAL_ERROR;
      enqueueError(message);
      Sentry.captureEvent({
        message,
        level: 'error',
        logger: 'ExamHttpService',
      });
    }

    return Promise.reject(failedRequest);
  },
);

axiosExamInstance.interceptors.request.use(
  config => {
    if (isBrowser()) {
      const token = ExamCookieService.getAccessToken();
      // @ts-ignore
      if (token && !config?.guestMode) config.headers.Authorization = `Bearer ${token}`;
    }

    // for ssr
    if (config.headers?.serverAuthorization) {
      config.headers.Authorization = `Bearer ${config.headers.serverAuthorization}`;
    }

    return config;
  },
  error => Promise.reject(error),
);

export default new ServiceBuilder().setEndpoint(EXAM_API_BASE).setStandalone(axiosExamInstance as any);
